export class Facility {
    public id: number;
    public name: string;

    constructor(facility: any = {}) {
        this.id = facility.id;
        this.name = facility.name;
    }
}
